import React from 'react'

const Road = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
    <polygon fill="#a8a8a8" points="20,18 20,15 18,15 18,18 15,18 15,20 18,20 18,23 20,23 20,20 23,20 23,18"/>
    <rect fill="#a8a8a8" height="9" width="2" x="18" y="4"/>
    <rect fill="#a8a8a8" height="16" width="2" x="4" y="4"/>
    <rect fill="#a8a8a8" height="4" width="2" x="11" y="4"/>
    <rect fill="#a8a8a8" height="4" width="2" x="11" y="10"/>
    <rect fill="#a8a8a8" height="4" width="2" x="11" y="16"/>
  </svg>
)

export default Road;